import { createFileRoute } from '@tanstack/react-router';
import { FinanceLayout } from '@/features/finance';

/** Finance: a section navigation (quotes, contracts, invoices, payments, expenses, dashboard). */
export const Route = createFileRoute('/_auth/o/$orgId/finance')({
  component: FinanceLayout,
});
